import { createLivePreviewRequestHandler } from "src/utils/livePreviewHandler";

/**
 * Live preview request handler for `past-events` (no drafts on this collection).
 */
export const pastEventsLivePreviewRequestHandler = createLivePreviewRequestHandler(
  ({ serverURL, apiPath, docId }) => `${serverURL}${apiPath}/past-events/${docId}?depth=1`
);
